import React from 'react';
import PropTypes from 'prop-types';
import { rupiah } from 'utils/formatter';
import styles from './Tax.css';

class Tax extends React.Component {
  render() {
    const { paymentTaxes, includeGratuityTax } = this.props;
    return (
      paymentTaxes.length > 0 && (
        <div className="row">
          <div className="col-md-12">
            <label>Tax</label>
            <table
              className="table mk-table-summary table-truncate"
              style={{ marginBottom: '20px' }}
            >
              <tbody>
                {paymentTaxes.map((tax, idxdisc) => (
                  <tr key={idxdisc}>
                    <td
                      width="70%"
                      className="name-item-refund tax-grat-disc"
                      style={{ border: 'none !important' }}
                    >
                      {tax.name} {includeGratuityTax && '(Included)'}
                    </td>
                    <td
                      width="30%"
                      className={`text-right price text-gray ${
                        styles['tax-price']
                      }`}
                    >
                      {!includeGratuityTax &&
                        rupiah(this._calculateTax(tax.id))}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )
    );
  }

  _calculateTax = taxId => {
    return this.props.calculateTax(taxId);
  };
}

Tax.propTypes = {
  paymentTaxes: PropTypes.array,
  includeGratuityTax: PropTypes.bool,
  // calculateTax(tax_id)
  calculateTax: PropTypes.func,
};

export default Tax;
